import { createSelector, createSlice } from '@reduxjs/toolkit';
import { sortItems } from '@utils/functions.js';

const initialState = {
  isLoading: false,
  isActive: false,
  id: 0,
  uid: 0,
  sid: 0,

  blockContent: {
    items: [],
    heading: {
      title: '',
      description: '',
      textAlign: 'left',
      image: '',
      divider: '',
      position: '',
    },
  },
  itemDesign: {},
  containerDesign: {},
};

export const outfitSlice = createSlice({
  name: 'outfit',
  initialState,
  reducers: {
    outfitStore: (state, action) => {
      const { id, isActive, sid, uid, data } = action.payload;

      const block = data ?? {};
      const { blockContent, blockDesign } = block;
      const { itemDesign, containerDesign } = blockDesign;

      state.isLoading = false;
      state.id = id ?? 0;
      state.isActive = isActive;
      state.sid = sid;
      state.uid = uid;

      // state.itemDesign = {
      //   shape: itemDesign.shape ?? 'round',
      //   border: itemDesign.border ?? 'none',
      //   borderColor: itemDesign.borderColor ?? '#000000',
      //   shadow: itemDesign.shadow ?? 'none',
      //   shadowColor: itemDesign.shadowColor ?? '#000000',
      // };
      state.itemDesign = itemDesign ?? {};
      state.containerDesign = containerDesign ?? {};

      state.blockContent = {
        items: blockContent.items ?? [],
        heading: {
          title: blockContent.heading.title ?? '',
          description: blockContent.heading.description ?? '',
          textAlign: blockContent.heading.textAlign ?? 'left',
          image: blockContent.heading.image ?? '',
          divider: blockContent.heading.divider ?? '',
          position: blockContent.heading.position ?? '',
        },
      };
    },
    outfitClear: () => initialState,

    outfitUpdateIsLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    outfitUpdateIsActive: (state, action) => {
      state.isActive = action.payload;
    },
    outfitUpdateBlockContent: (state, action) => {
      state.blockContent = action.payload;
    },
    outfitUpdateBlockDesign: (state, action) => {
      state.blockDesign = action.payload;
    },
  },
});

export const { outfitStore, outfitClear, outfitUpdateIsLoading, outfitUpdateIsActive, outfitUpdateBlockContent, outfitUpdateBlockDesign } = outfitSlice.actions;

export const selectOutfitIsLoading = (state) => state.outfit.isLoading;

export const selectOutfitId = (state) => state.outfit.id;
export const selectOutfitUID = (state) => state.outfit.uid;
export const selectOutfitSID = (state) => state.outfit.sid;

export const selectOutfitBlockContent = (state) => state.outfit.blockContent;
export const selectOutfitBlockDesign = (state) => state.outfit.blockDesign;
export const selectOutfitSortItems = createSelector([selectOutfitBlockContent], ({ items }) => {
  return sortItems(items);
});

export const selectOutfitItemDesign = (state) => state.outfit.itemDesign;
export const selectOutfitContainerDesign = (state) => state.outfit.containerDesign;

export default outfitSlice.reducer;
